export const SET_INSTANCE = "@quizInstance/setInstance"
export const SET_ANSWER_COUNT = "@quizInstance/setAnswerCount"
export const ADD_JOINED_PLAYER = "@quizInstance/setJoinedPlayers"
export const REMOVE_JOINED_PLAYER = "@quizInstance/removeJoinedPlayers"
export const SET_GAME_INSTANCE_LEADERBOARD = "@leaderboard/setGameInstanceLeaderboard"
export const FETCH_INSTANCE = "@quizInstance/fetchInstance"
